// Add-to-calendar helpers: Google Calendar URL, .ics download, WhatsApp share.

function toCalStamp(iso) {
  // Convert ISO string to YYYYMMDDTHHmmssZ (UTC)
  const d = new Date(iso);
  return d
    .toISOString()
    .replace(/[-:]/g, "")
    .replace(/\.\d{3}/, "");
}

export function googleCalendarUrl(ev) {
  const start = toCalStamp(ev.startISO);
  const end = toCalStamp(ev.endISO);
  const details = encodeURIComponent(
    `${ev.title}\n\nComplimentary admission. Live sharing, practical examples and Q&A.`
  );
  const location = encodeURIComponent(ev.venue || "Venue to be confirmed");
  const text = encodeURIComponent(ev.title);
  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${text}&dates=${start}/${end}&details=${details}&location=${location}`;
}

export function buildICS(ev) {
  const start = toCalStamp(ev.startISO);
  const end = toCalStamp(ev.endISO);
  const now = toCalStamp(new Date().toISOString());
  const uid = `cpf-${start}@affinitygroup.sg`;
  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Affinity Group//CPF Seminar//EN",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    `UID:${uid}`,
    `DTSTAMP:${now}`,
    `DTSTART:${start}`,
    `DTEND:${end}`,
    `SUMMARY:${ev.title}`,
    `DESCRIPTION:Complimentary CPF Retirement Planning Seminar by Affinity Group.`,
    `LOCATION:${ev.venue || "Venue to be confirmed"}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ];
  return lines.join("\r\n");
}

export function downloadICS(ev) {
  const ics = buildICS(ev);
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "cpf-retirement-seminar.ics";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function whatsappShareUrl(ev) {
  const msg = encodeURIComponent(
    `I've reserved my seat for the ${ev.title} on ${ev.dateLabel}, ${ev.timeLabel}. Complimentary admission \u2014 join me! ${window.location.href}`
  );
  return `https://wa.me/?text=${msg}`;
}
